import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function SplashScreen({ subtitle }: { subtitle?: React.ReactNode }): JSX.Element {
  return (
    <div className="m-auto vertically-center">
      <div className="tw-text-center">
        <Spin indicator={<LoadingOutlined spin />} />
        {subtitle && <div>{subtitle}</div>}
      </div>
    </div>
  );
}
